import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapCancellationKindOptions = (
  option: UCM.CancellationKindOptionRawType,
): UCM.CancellationKindOptionType => ({
  value: option.id,
  label: option.code,
  backupable: option.backupable,
});

const getCancellationKindOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.CancellationKindOptionRawType>
  >(API.GET.cancellationKindOptions);
  return data.data.map(({ attributes }) =>
    mapCancellationKindOptions(attributes),
  );
};

export const useGetCancellationKindOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CANCELLATION_KIND_OPTIONS],
    queryFn: getCancellationKindOptions,
    ...config,
  });
};
